export const config = {
    apiKey: "AIzaSyBuqmEmntHihsdIaWkXEqsJVJ6U8XbowX8",
    authDomain: "quotes-fc74b.firebaseapp.com",
    databaseURL: "https://quotes-fc74b.firebaseio.com",
    projectId: "quotes-fc74b",
    storageBucket: "quotes-fc74b.appspot.com",
    messagingSenderId: "227040214982"
}

export const visionApiKey = 'AIzaSyC54HpAzAPkYDDXb2ahJd0qid3cljSfK8E';



// WEBPACK FOOTER //
// ./src/private/config.js